var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53516 13.4075C7.08642 13.4075 6.72266 13.7712 6.72266 14.22V19.9075C6.72266 20.3562 7.08642 20.72 7.53516 20.72H18.9102C19.3589 20.72 19.7227 20.3562 19.7227 19.9075V14.22C19.7227 13.7712 19.3589 13.4075 18.9102 13.4075H7.53516ZM7.53516 11.7825H18.9102C20.2564 11.7825 21.3477 12.8738 21.3477 14.22V19.9075C21.3477 21.2537 20.2564 22.345 18.9102 22.345H7.53516C6.18896 22.345 5.09766 21.2537 5.09766 19.9075V14.22C5.09766 12.8738 6.18896 11.7825 7.53516 11.7825Z",
    fill: "#756393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97266 12.595C9.97266 13.0437 9.60889 13.4075 9.16016 13.4075C8.71142 13.4075 8.34766 13.0437 8.34766 12.595V9.34497C8.34766 6.65258 10.5303 4.46997 13.2227 4.46997C15.915 4.46997 18.0977 6.65258 18.0977 9.34497V12.595C18.0977 13.0437 17.7339 13.4075 17.2852 13.4075C16.8364 13.4075 16.4727 13.0437 16.4727 12.595V9.34497C16.4727 7.55005 15.0176 6.09497 13.2227 6.09497C11.4277 6.09497 9.97266 7.55005 9.97266 9.34497V12.595Z",
    fill: "#756393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.fa594b57632c884f6878f9a48d92f33f.svg";
export { ForwardRef as ReactComponent };